import {getPeopleAttributeList, getPeopleAttributeListPerHour, getPeopleAttributeListPerDay} from '../../../api/eastCoastMonitorApi/peopleAttributeApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
  peopleAttributeList: [],
  peopleAttributeListPerHour: [],
  peopleAttributeListPerDay: [],
  todayAllPeopleAttributeList: []
}

const getters = {
  getCenterOverViewData: state => (scenicAreaId = -1) => {
    let target = state.peopleAttributeList
    if(scenicAreaId !== -1) {
      target = state.peopleAttributeList.filter(item => item.scenicAreaId === scenicAreaId)
    }
    
    const total = target.reduce((total, currentObj) => { 
        return { 
          manCount: total.manCount + currentObj.manCount ,
          womanCount: total.womanCount + currentObj.womanCount ,
          age0to11: total.age0to11 + currentObj.age0to11 ,
          age12to19: total.age12to19 + currentObj.age12to19 ,
          age20to29: total.age20to29 + currentObj.age20to29 ,
          age30to39: total.age30to39 + currentObj.age30to39 ,
          age40to49: total.age40to49 + currentObj.age40to49 ,
          age50to59: total.age50to59 + currentObj.age50to59 ,
          age60above: total.age60above + currentObj.age60above ,
        }
      }, 
      //初始物件做累加
      {manCount: 0, womanCount: 0, age0to11: 0, age12to19:0, age20to29: 0, age30to39: 0, age40to49: 0, age50to59: 0, age60above: 0}  
    );

    const allGenderCount = total.manCount + total.womanCount
    const allAgeCount = total.age0to11 + total.age12to19 + total.age20to29 + total.age30to39 + total.age40to49 + total.age50to59 + total.age60above

    total.manRatio = allGenderCount === 0? 0 : Math.round(total.manCount/allGenderCount*100)
    total.womanRatio = allGenderCount === 0? 0 : Math.round(total.womanCount/allGenderCount*100)
    total.age0to11Ratio = allAgeCount === 0? 0 : Math.round(total.age0to11/allAgeCount*100)
    total.age12to19Ratio = allAgeCount === 0? 0 : Math.round(total.age12to19/allAgeCount*100)
    total.age20to29Ratio = allAgeCount === 0? 0 : Math.round(total.age20to29/allAgeCount*100)
    total.age30to39Ratio = allAgeCount === 0? 0 : Math.round(total.age30to39/allAgeCount*100)
    total.age40to49Ratio = allAgeCount === 0? 0 : Math.round(total.age40to49/allAgeCount*100)
    total.age50to59Ratio = allAgeCount === 0? 0 : Math.round(total.age50to59/allAgeCount*100)
    total.age60aboveRatio = allAgeCount === 0? 0 : Math.round(total.age60above/allAgeCount*100)

    return total
  },

  getSearchAttributeData: (state) => (selectType) => {
    // state.peopleAttributeList
    const resultData = []

    switch(selectType) {
      case CONST.PEOPLE_ATTRIBUTE_TYPE.GENDER:
        state.peopleAttributeList.forEach(e => {
          
          resultData.push({scenicAreaName: e.scenicAreaName, gender: CONST.GENDER.MALE, age: '-', count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.MAN_COUNT], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.MAN_RATIO]*100)})
          resultData.push({scenicAreaName: e.scenicAreaName, gender: CONST.GENDER.FEMALE, age: '-', count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.WOMAN_COUNT], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.WOMAN_RATIO]*100)})
        });
        break
      
      case CONST.PEOPLE_ATTRIBUTE_TYPE.AGE: 
        state.peopleAttributeList.forEach(e => {
            
          resultData.push({scenicAreaName: e.scenicAreaName, gender: '-', age: CONST.AGE.AGE_0_11, count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_0_11], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_0_11_RATIO]*100)})
          resultData.push({scenicAreaName: e.scenicAreaName, gender: '-', age: CONST.AGE.AGE_12_19, count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_12_19], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_12_19_RATIO]*100)})
          resultData.push({scenicAreaName: e.scenicAreaName, gender: '-', age: CONST.AGE.AGE_20_29, count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_20_29], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_20_29_RATIO]*100)})
          resultData.push({scenicAreaName: e.scenicAreaName, gender: '-', age: CONST.AGE.AGE_30_39, count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_30_39], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_30_39_RATIO]*100)})
          resultData.push({scenicAreaName: e.scenicAreaName, gender: '-', age: CONST.AGE.AGE_40_49, count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_40_49], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_40_49_RATIO]*100)})
          resultData.push({scenicAreaName: e.scenicAreaName, gender: '-', age: CONST.AGE.AGE_50_59, count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_50_59], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_50_59_RATIO]*100)})
          resultData.push({scenicAreaName: e.scenicAreaName, gender: '-', age: CONST.AGE.AGE_60_ABOVE, count: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_60_ABOVE], ratio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_60_ABOVE_RATIO]*100)})
        });
        break  
    }

    return resultData
  },

  getSearchGenderPerHour: (state) => {
    return helpers.genGenderData(state.peopleAttributeListPerHour)
  },

  getSearchGenderPerDay: (state) => {
    return helpers.genGenderData(state.peopleAttributeListPerDay)
  },

  getSearchAgePerDay: () => {
    const resultData = []
    state.peopleAttributeListPerDay.forEach(e => {
          
    resultData.push({
      scenicAreaName: e.scenicAreaName, 
      childCount: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_CHILD],
      childRatio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_CHILD_RATIO]*100),
      adultCount: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_ADLUT],
      adultsRatio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_ADLUT_RATIO]*100),
      eldersCount: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_ELDER],
      eldersRatio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_ELDER_RATIO]*100),
      startTime: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.START_TIME],
      endTime: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.END_TIME],
      })
    });

    return resultData
  },

  getSearchAgePerHour: () => {
    const resultData = []
    state.peopleAttributeListPerHour.forEach(e => {
          
    resultData.push({
      scenicAreaName: e.scenicAreaName, 
      childCount: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_CHILD],
      childRatio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_CHILD_RATIO]*100),
      adultCount: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_ADLUT],
      adultsRatio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_ADLUT_RATIO]*100),
      eldersCount: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_ELDER],
      eldersRatio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_ELDER_RATIO]*100),
      startTime: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.START_TIME],
      endTime: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.END_TIME],
      })
    });

    return resultData
  }

}

const actions = {
  async getPeopleAttributeList({ commit }, condition = {}) {
    const result = await getPeopleAttributeList(condition)

    if(result.success){
      commit('peopleAttributeList', result.data)
      // commit('todayAllPeopleAttributeList', result.data)
    }
  },

  async getPeopleAttributeListPerHour({ commit }, condition = {}) {
    const result = await getPeopleAttributeListPerHour(condition)

    if(result.success){
      commit('peopleAttributeListPerHour', result.data)
    }
  },

  async getPeopleAttributeListPerDay({ commit }, condition = {}) {
    const result = await getPeopleAttributeListPerDay(condition)

    if(result.success){
      commit('peopleAttributeListPerDay', result.data)
    }
  },
}

const mutations = {
  peopleAttributeList(state, data) {
    state.peopleAttributeList = data
  },

  peopleAttributeListPerHour(state, data) {
    state.peopleAttributeListPerHour = data
  },

  peopleAttributeListPerDay(state, data) {
    state.peopleAttributeListPerDay = data
  },

  todayAllPeopleAttributeList(state, data) {
    state.todayAllPeopleAttributeList = data
  },
}

const helpers = {
  genGenderData(list) {
    const resultData = []
    list.forEach(e => {
          
    resultData.push({
      scenicAreaName: e.scenicAreaName, 
      areasSort: e.areasSort,
      manCount: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.MAN_COUNT],
      manRatio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.MAN_RATIO]*100),
      womanCount: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.WOMAN_COUNT],
      womanRatio: Math.round(e[CONST.PEOPLE_ATTRIBUTE_API_KEY.WOMAN_RATIO]*100),
      startTime: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.START_TIME],
      endTime: e[CONST.PEOPLE_ATTRIBUTE_API_KEY.END_TIME],
      })
    });

    return resultData
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}